import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "../Components/Sidebar";
import React, { useContext, useState } from "react";
import AmeyoBotLogoV1 from "../Components/AmeyoBotLogoV1";
import { AmeyoContext } from "../utils/AmeyoContext";
function Layout() {
  const user = useSelector((state) => state?.user?.userDetails);
  const isAuthenticated = user && user?.UserDetails?.email;
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
  };

  const {
    minimized,
    showDialog,
    closeDialog,
    showPanel,
    closePanel,
    showAmeyoPanel,
  } = useContext(AmeyoContext);

  console.log(showAmeyoPanel, "ameyo panel");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
        backgroundColor: "#F1F4FA",
        height: "100vh",
        transition: "0.5s ease-in-out",
        // gap:"20px"
      }}
    >
      {isAuthenticated && (
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          toggleSidebar={handleSidebarToggle}
        />
      )}
      <div
        style={{
          flex: 1,
          transition: "0.5s ease-in-out",
          overflowY: "auto",
          overflowX: "hidden",
          backgroundColor: "#F1F4FA",
          height: "100vh",
          position: "relative",
          marginLeft: "10px",
          marginRight: "10px",
        }}
      >
        <Outlet />
        {isAuthenticated && (
          <AmeyoBotLogoV1
            minimized={minimized}
            showDialog={showDialog}
            closeDialog={closeDialog}
            showPanel={showPanel}
            closePanel={closePanel}
            showAmeyoPanel={showAmeyoPanel}
          />
        )}
      </div>
    </div>
  );
}

export default Layout;
